import {Box,Typography,Button, CircularProgress, FormControlLabel, FormControl, FormLabel, Radio, IconButton, RadioGroup} from "@mui/material"
import 'react-h5-audio-player/lib/styles.css';
import ReactPlayer from 'react-player'
import { CalendarMonth, Timelapse } from "@mui/icons-material";
import EditorText from "./EditorText";

const AssQuestionView = ({content,data,title,subTime,newSection,time,hasStarted,sectionTime,setMessage,message,handleSend,submitting,type,recentQuestion,setNewSection,setIsPaused})=>{
  
const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}; 

    return (
        <Box style={{width:450}}>
            <Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="80%">
                <Typography style={{color:'white',marginBottom:5}}>
                    {title}
                </Typography>
                <Typography pl={2} style={{color:"gold",fontSize:13,width:100}}>
                    {time}
                </Typography> 
            </Box>
            <Typography m={1} style={{color:"gold",fontSize:13,width:200}}>
                {subTime} / {formatTime(sectionTime)}
            </Typography> 
            {!newSection && (
                <Box>
                    <Typography color="gray" style={{fontFamily:"dinofans"}}>
                        Section
                    </Typography>
                    <Typography sx={{color:'white',marginBottom:1}}>
                        {data?.title || ""}
                    </Typography>
                    <Typography color="gray" style={{fontFamily:"dinofans"}}>
                        {recentQuestion+1}#  Question
                    </Typography>
                </Box>
            )
            }

            <Box sx={{justifyContent:"flex-start",alignItems:"flex-start",margin:1}}>
                {
                    hasStarted ? 
                    <>
                        {
                        newSection ?
                            <Box mb={2} ml={4}>
								<Typography color="gold" style={{fontFamily:"dinofans",marginBottom:5}}>
									Section Info
								</Typography>
                                <Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="80%">
                                    <Box>
										<Typography color="gray" style={{fontFamily:"dinofans"}}>
											Title
										</Typography>
										<Typography sx={{color:'white',marginBottom:1}}>
											{data?.title}
										</Typography>
									</Box>
                                    <Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                                        <IconButton>
                                            <Timelapse style={{color:"gray"}}/>
                                        </IconButton>
                                        <Typography color="white" fontSize={14} width={80}>
                                            {data?.duration} min
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="65%">
                                    <Box>
                                        <Typography color="gray" style={{fontFamily:"dinofans"}}>
                                            Questions
                                        </Typography>
                                        <Typography sx={{color:'white',marginBottom:1}}>
                                            {data?.total_questions}
                                        </Typography>
                                    </Box>
                                    <Box >
                                        <Typography color="gray" style={{fontFamily:"dinofans"}}>
                                            Points
                                        </Typography>
                                        <Typography sx={{color:'white',marginBottom:1}}>
                                            {data?.total_point}
                                        </Typography>
                                    </Box>
                                </Box>
								<Box ml={1}>
									<Typography color="gray" style={{fontFamily:"dinofans"}}>
										Description
									</Typography>
									<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
										{data?.description}
									</Typography>
									<Typography color="gray" style={{fontFamily:"dinofans"}}>
										Level
									</Typography>
									<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
										{data?.level}
									</Typography>
								</Box>
                            </Box>
                        :
                            <>
                            <Typography sx={{fontFamily:"dinofans",fontSize:13,pb:1}}>
                                Question
                            </Typography>
                            <Typography sx={{fontSize:13,padding:1,whiteSpace:"pre-wrap",marginBottom:1}}>
                                {content}  
                            </Typography>
                            {
                                data?.hasVideo && (
                                    <Box ml={2}>
                                        <ReactPlayer url={data?.videoUrl} width={280} height={150} controls style={{borderRadius:5}}/>
                                    </Box>
                                ) 
                            }
                            {
                                data?.hasImage  && (
                                    <Box ml={2} sx={{justifyContent:"center",alignItems:"center",width:"100%"}}>
                                        <img resizemode="cover" src={data?.imageUrl} width={300} height={150} style={{borderRadius:2}}/>
                                    </Box>
                                ) 
                            }
                            {
                                data?.hasAudio && (
                                    <Box ml={2} sx={{justifyContent:"center",alignItems:"center"}}>
                                        <audio
                                            src={data?.audioUrl}
                                            controls
                                            style={{width:250,height:50}}
                                        />
                                    </Box>
                                ) 
                            }
                            {
                                type === "simple answer"  && (
                                    <Box justifyContent="center" alignItems="center" width="80%" mt={2} mb={2} ml={2}>
                                        <EditorText
                                            data={message}
                                            setData={setMessage}
                                            width="95%"
                                            label="answer"
                                            isRequired={true}
                                            maxRow={4}
                                        />
                                    </Box>
                                ) 
                            }
                            {
                                type !== "simple answer"  && (
                                    <Box justifyContent="center" alignItems="center" width="80%" mt={2} mb={2}>
                                        <FormControl >
                                            <FormLabel sx={{fontFamily:"dinofans",fontSize:13,color:"#fff", mb:1}} id="demo-row-radio-buttons-group-label">Choose :</FormLabel>
                                                <RadioGroup
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    sx={{ml:2}}
                                                    value={message}
                                                >
                                                {data?.responses?.map((item,index)=>(
                                                    <FormControlLabel key={index} sx={{fontSize:10,mt:1}}  value={item} control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                                        setMessage(item)
                                                    }} />} label={<Typography sx={{fontSize:12,m:1}}>{item}</Typography>} />
                                                    ))
                                                }
                                                </RadioGroup>                        
                                        </FormControl>
                                    </Box> 
                                )
                            }
                            </>
                        }
                    </>
                    :
                    <Typography sx={{fontSize:13,padding:1,whiteSpace:"pre-wrap",margin:3,marginBottom:1}}>
                        We thank you for taking this assessment,soon you will receive your score that you can view on your dashboard
                    </Typography>
                }
               {
                newSection ? 
                    <Button onClick={async (e)=>{
                        e?.preventDefault()
                        setIsPaused(false)
                        setNewSection(false)
                    }} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
                       Start
                    </Button>
                :
                    <Button onClick={async (e)=>{
                        e?.preventDefault()
                        await handleSend()
                    }} disabled={submitting ? true : false} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
                        {
                            submitting ?  <CircularProgress size={20} sx={{color:"#fff"}}/>  :  (!submitting && newSection) ? "Start" : "Send"
                        }
                    </Button>
               }
            </Box>
        </Box>
    )	
}


export default AssQuestionView


